export default __webpack_public_path__ + "static/17-c1b251e6b419b39c96203357bcf4302d.jpg";